import Image from 'next/image'
import ButtonIcon from './ButtonIcon'

// type TeamMemberCardProps = {
//     index : number
//   setPopUpIndex : number
//   setOpenPopUp : boolean
//   photoSmallUrl: string
//   photoBigUrl?: string
//   name: string
//   role?: string
//   link?: string
//   signUrl?: string
//   quote?: string
//   info?: string[]
// }

const TeamMemberCard = ({
  index,
  setPopUpIndex,
  setOpenPopUp,
  photoSmallUrl,
  name,
  role = '',
  alt = '',
  link,
}) => {



  const setPopUp = (index) => {
    setOpenPopUp(true)
    setPopUpIndex(index)
  }


  return (
    <figure className="flex group flex-col">


      <button  aria-label={`Открыть информацию о ${name}${role ? `, ${role}` : ''}`} onClick={()=> {setPopUp(index)}} className=" cursor-pointer mb-[1.2rem] aspect-[0.8/1] relative w-full">
        <Image
          src={photoSmallUrl}
          alt={alt}
          fill
          sizes="600px"
          className="w-auto object-cover"
        />

        <span className='hidden lg:block group-hover:opacity-100 opacity-0 transition-opacity duration-300 absolute inset-0 bg-[radial-gradient(559.52%_675.18%_at_-77.85%_23.92%,rgba(16,20,35,0)_0%,#101423_100%),radial-gradient(369.32%_100%_at_50%_100%,rgba(154,144,189,0.5)_0%,rgba(228,225,239,0)_61.22%)]'>

        </span>

        <span  className="flex hover:bg-dusty-blue hover:text-white transition-colors h-[3.2rem] w-[3.2rem] items-center cursor-pointer justify-center bg-dusty-green text-btn absolute right-[1.2rem] bottom-[1.2rem] z-10 lg:hidden">
          <img
            className="-rotate-45 w-[1.4rem] h-[1.4rem]"
            src="/images/arrow_right.svg"
            fetchPriority="low"
            alt="Стрелка вправо"
          />
        </span>
      </button>

      <figcaption className="flex flex-col">
        {role && (
          <p className="text-dark-blue text-1 mb-[1rem]">{role}</p>
        )}
      {link ? (
        <a
          href={link}
          className="relative w-fit text-dark-blue lg:group-hover:text-dusty-green-dark transition-colors duration-300 p1
                      after:content-[''] after:absolute after:left-0 after:-bottom-[0.2rem] after:h-[1px] after:w-0 after:bg-current after:transition-all after:duration-300 lg:group-hover:after:w-full"
        >
          {name}
        </a>
      ) : (
        <p
          className="relative w-fit text-dark-blue lg:group-hover:text-dusty-green-dark transition-colors duration-300 text-link
                    after:content-[''] after:absolute after:left-0 after:-bottom-[0.2rem] after:h-[1px] after:w-0 after:bg-current after:transition-all after:duration-300 lg:group-hover:after:w-full"
        >
          {name}
        </p>
      )}
      </figcaption>
    </figure>
  )
}

export default TeamMemberCard